// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./bg_menu.jpg");
var dir = previousRequest.replace("bg_menu.jpg", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "bg_menu.jpg",
	name: "bg_menu",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/bg/bg_menu.jpg
// module id = 998
// module chunks = 4